import { useNavigate } from "react-router-dom";

import { SEGMENT_BUILDER_TOUR } from "./segmentBuilderTour";
import { useSegmentTourLink } from "./useSegmentTourLink";

import { useTourPromo } from "@/features/tours/useTourPromo";

export function useSegmentTourPromo() {
  const navigate = useNavigate();
  const { isActive, isCardDismissed, isBannerDismissed, dismissCard, dismissBanner } =
    useTourPromo(SEGMENT_BUILDER_TOUR);

  const { link, getFreshLink } = useSegmentTourLink({
    enabled: isActive && (!isCardDismissed || !isBannerDismissed),
  });
  const isLinked = link !== null;

  const startTour = async () => {
    const target = await getFreshLink();
    if (!target) return;
    navigate(target);
  };

  return {
    showHomeCard: isActive && !isCardDismissed && isLinked,
    showBanner: isActive && !isBannerDismissed && isLinked,
    dismissCard,
    dismissBanner,
    startTour,
  };
}
